'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/checkbox/style/index.js
// module id = 1215
// module chunks = 0